// needs to be here in order to overwrite redux-segment location change actions for page view posts.
export default {
    mapper: {
        '@@router/LOCATION_CHANGE': () => {
            return {};
        },
    },
};
